import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import { FOOTER_LINK_CLICK } from "constants/bigbrain-event-types";
import { MONDAY_LOGO_SRC, ROOT_LINK } from "constants/links";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import { StyledFooterCategoryComponent } from "./footer-category-component.scss";
import { normalizeUrl } from "/utils/url";
import { trackEvent } from "/services/bigbrain-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getBrandLogoSrc } from "/services/brand-service";
const FooterCategoryComponent = (props)=>{
    const { title, translate, links, hasMondayLogoTitle, footerCatalogLinks, isNewBrand } = props;
    const trackLinkClick = (event)=>{
        const { target } = event;
        const href = normalizeUrl(target.href);
        trackEvent(FOOTER_LINK_CLICK, {
            kind: href
        });
    };
    const resolveLink = (linkKey)=>{
        const link = links[linkKey];
        const rawHref = link === null || link === void 0 ? void 0 : link.href;
        var _footerCatalogLinks_rawHref;
        const href = (_footerCatalogLinks_rawHref = footerCatalogLinks === null || footerCatalogLinks === void 0 ? void 0 : footerCatalogLinks[rawHref]) !== null && _footerCatalogLinks_rawHref !== void 0 ? _footerCatalogLinks_rawHref : rawHref;
        return {
            href,
            icon: link === null || link === void 0 ? void 0 : link.icon,
            openInNewTab: link === null || link === void 0 ? void 0 : link.openInNewTab,
            tag: link === null || link === void 0 ? void 0 : link.tag
        };
    };
    const linkRenderer = (linkKey, index)=>{
        const { href, icon, openInNewTab, tag } = resolveLink(linkKey);
        return /*#__PURE__*/ _jsx("div", {
            className: "link",
            children: /*#__PURE__*/ _jsxs("a", {
                onClick: trackLinkClick,
                href: href,
                target: openInNewTab ? "_blank" : "_self",
                rel: "noreferrer",
                children: [
                    icon && /*#__PURE__*/ _jsx("span", {
                        className: "footer-link-icon",
                        children: typeof icon === "function" ? (()=>{
                            const I = icon;
                            return /*#__PURE__*/ _jsx(I, {});
                        })() : /*#__PURE__*/ _jsx(PictureComponent, {
                            src: icon
                        })
                    }),
                    translate(linkKey),
                    tag && /*#__PURE__*/ _jsx("div", {
                        className: "link-tag",
                        children: translate(tag)
                    })
                ]
            })
        }, index);
    };
    const linksRenderer = ()=>{
        return Object.keys(links).map(linkRenderer);
    };
    return /*#__PURE__*/ _jsxs(StyledFooterCategoryComponent, {
        className: "footer-category-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "footer-category-image-and-title-warpper",
                children: [
                    hasMondayLogoTitle && /*#__PURE__*/ _jsx("div", {
                        className: "monday-logo-wrapper",
                        children: /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                            src: getBrandLogoSrc(MONDAY_LOGO_SRC, isNewBrand),
                            className: "footer-monday-logo-image",
                            href: ROOT_LINK,
                            alt: "Go to monday.com homepage"
                        })
                    }),
                    title && /*#__PURE__*/ _jsx("div", {
                        className: "title",
                        children: translate(title)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "links",
                children: linksRenderer()
            })
        ]
    });
};
export default withGenericConfig(FooterCategoryComponent);
